import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Profile from "../views/Profile.vue";
import Orders from "../views/Orders.vue";
import Contacts from "../views/Contacts.vue";
import Login from "../views/Login.vue";
import Support from "../views/Support.vue";
import Order from "../views/Order.vue";
import RefundRules from "../views/RefundRules.vue";
import RefundMain from "../views/RefundMain.vue";
import UserOffers from "../views/UserOffers.vue";
import Offer from "../views/ExistingOffer.vue";
import UserTickets from "../views/UserTickets.vue";
import SupportTicket from "../views/SupportTicket.vue";
import store from "../store/index";
import Success from "../views/Success.vue";
import OrderPassengersCard from "../components/OrderPassengersCard.vue";
import OrderPrice from "../components/OrderPrice.vue";
import RouteCardInfo from "../components/RouteCardInfo.vue";
import OrderDocs from "../components/OrderDocs.vue";
import AeroExpressSchedule from "../components/AeroExpressSchedule.vue";
import axios from "axios";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/orders",
    name: "Orders",
    component: Orders,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: Contacts,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/RefundRules",
    name: "RefundRules",
    component: RefundRules,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/Refund/:guid/:pnr/:ticketNumber",
    name: "Refund",
    component: RefundMain,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/success",
    name: "Success",
    component: Success,
    props: {
      requestNumber: {
        type: [String, Number],
      },
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/support/:guid?",
    name: "Support",
    component: Support,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/offers",
    name: "UserOffers",
    component: UserOffers,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/offer/:offerId",
    name: "Offer",
    component: Offer,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },

  {
    path: "/issues",
    name: "UserTickets",
    component: UserTickets,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/issues/:ticketId",
    name: "SupportTicket",
    component: SupportTicket,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      requiredAuth: false,
      title: "Вход в личный кабинет",
    },
  },
  {
    path: "/order/:order",
    name: "Order",
    component: Order,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/order/:order/passengers",
    name: "OrderPassengersCard",
    component: OrderPassengersCard,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/order/:order/price",
    name: "OrderPrice",
    component: OrderPrice,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/order/:order/:flightId/info",
    name: "RouteCardInfo",
    component: RouteCardInfo,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/order/:order/documents/:pnr/:route",
    name: "OrderDocs",
    component: OrderDocs,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: "/order/:order/AeroExpressSchedule/:codeDepRus/:codeArrRus/:time",
    name: "AeroExpressSchedule",
    component: AeroExpressSchedule,
    props: true,
    meta: {
      requiredAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

const axioCred = axios.create({
  withCredentials: true,
});

async function justRequest() {
  const json = await axioCred.post(
    `https://www.biletdv.ru/customer/IBEServices/IsAuthenticated`
  );
  if (json && json.data.Cookie !== null) {
    if (
      json.data.roles.includes("Partner") ||
      json.data.roles.includes("Subagent") ||
      json.data.roles.includes("TourOpAgent")
    ) {
      window.location.replace("http://avia.biletdv.ru");
    } else {
      store.commit("auth/saveTokenData", json.data);
      store.commit("auth/setLoginStatus", "success");
      const userData = await axioCred.get(
        "https://www.biletdv.ru/customer/IBEServices/GetBonusesInfo"
      );
      const bonusInfo = userData.data;
      sessionStorage.setItem("userInfo", JSON.stringify(bonusInfo));
    }
  } else {
    store.dispatch("auth/logout");
    store.commit("auth/setLoginStatus", "failed");
  }
}

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error.response.data);
    if (error.response.status === 401) {
      store.commit("auth/logout");
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

router.beforeEach(async (to, from, next) => {
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        store.dispatch("auth/logout");
        router.push("/login");
      }
      return Promise.reject(error);
    }
  );
  if (!store.getters["auth/getAuthData"].token) {
    const loginPath = window.location.pathname;
    await justRequest();
    const access_token = sessionStorage.getItem("access_token");
    const userName = sessionStorage.getItem("userName");
    const roles = sessionStorage.getItem("roles");
    if (access_token && userName && roles) {
      const storedData = {
        EncryptedAuthTicket: JSON.parse(access_token),
        userName: JSON.parse(userName),
        roles: JSON.parse(roles),
      };
      store.commit("auth/saveTokenData", storedData);
    }
  }
  const auth = store.getters["auth/isTokenActive"];

  if (to.fullPath == "/") {
    return next({ path: "/login" });
  } else if (auth && !to.meta.requiredAuth) {
    return next({ path: "/orders" });
  } else if (!auth && to.meta.requiredAuth) {
    return next({ path: "/login" });
  } else {
    return next();
  }
});

export default router;
